import { Dialog, DialogContent, DialogActions, Box } from '@mui/material';
import TypographyLevel from 'shared/components/Typography';
import { ButtonComp } from 'shared/components/AppComponents';
import { ReactElement } from 'react';

/**
 * AddClientDialog component.
 * Renders the dialog for adding a new client.
 * @param {AddClientDialogProps} props - The component props.
 * @returns {ReactElement} AddClientDialog component.
 */
const AddClientDialog = ({
    dialogAdd,
    setDialogAdd,
    setStatusPage,
}: AddClientDialog): ReactElement => (
    <Dialog
        open={dialogAdd}
        onClose={() => setDialogAdd(false)}
        maxWidth="md"
        classes={{ paper: 'client-dialog-container' }}
        className="container-add-client-dialog"
    >
        <DialogContent dividers className="dialog-content">
            <Box className="dialog-description">
                <Box className="dialog-head">
                    <TypographyLevel variant="one">
                        <Box>Checklists added successfully</Box>
                    </TypographyLevel>
                </Box>

                <Box className="dialog-desc">
                    <TypographyLevel variant="three">
                        You will be notified when the checklist be <br />
                        validated by the support team
                    </TypographyLevel>
                </Box>
            </Box>
        </DialogContent>

        <DialogActions className="dialog-actions">
            <Box className="dialog-actions-button">
                <ButtonComp
                    width="16rem"
                    onClick={() => {
                        setStatusPage('view');
                        setDialogAdd(false);
                    }}
                    type="primary"
                >
                    Go to Manage Checklists
                </ButtonComp>
            </Box>
        </DialogActions>
    </Dialog>
);

export default AddClientDialog;
